import { render, staticRenderFns } from "./CadastrarHelp.vue?vue&type=template&id=7def9083&scoped=true"
import script from "./CadastrarHelp.vue?vue&type=script&lang=js"
export * from "./CadastrarHelp.vue?vue&type=script&lang=js"
import style0 from "./CadastrarHelp.vue?vue&type=style&index=0&id=7def9083&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def9083",
  null
  
)

export default component.exports